import React, {Component} from 'react';
import RecordSearchForm from '../containers/RecordSearchForm';
import Records from '../containers/Records';
import { connect } from 'react-redux';

class Home extends Component {
    render() {
        return ( 
            <div>
                <div style={{position:'absolute', zIndex:100}}>
                    <RecordSearchForm />
                </div>
                <br /><br /><br /><br />
                <div><Records /></div>
                <br /><br /><br /><br />
            </div>
        )
    }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/layouts/Home.js